import { useQuery } from '@tanstack/react-query'
import { supabase } from '../api'

const getReports = async (
  userId?: number | string | undefined,
  targetId?: string | undefined,
) => {
  let req = supabase
    .from('reports')
    .select('*')
  if (userId) {
    req = req.eq('creator_user_id', userId)
  }
  if (targetId) {
    req = req.eq('target', targetId)
  }
  const { data, error } = await req

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useReports({ userId, targetId }: {
  userId?: string | number | undefined,
  targetId?: string | undefined,
}) {
  return useQuery({
    queryKey: ['reports', userId, targetId],
    queryFn: () => getReports(userId, targetId),
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
  })
}
